export default __webpack_public_path__ + "static/media/osoAndino.712bf91c.png";